import React, { useState } from "react";
import ScoreMemberCard from "../ScoreItem/ScoreMemberCard";
import { IRecipientModel } from "../../../../Models/Recipient";
import ModuleOverviewModal from "../../../../Pages/PartnerModules/ModuleOverviewModal";
import TaskList from "../../../Assessment/TaskList/TaskList";
import FamilyIcon from "../../../../Images/Icons/Family Icon.png";
import FamilyModuleDescription from "../../../../Pages/PartnerModules/FamilyModuleDescription";
import TaskModal from "../ModuleTasks/ModuleModal/TaskModal";
import { observer } from "mobx-react-lite";
import { moduleTitles } from "../../../Enums/TitleEnums"

export interface IFamilyScoreCardProps {
  selectedRecipient: IRecipientModel;
  caregiverId: string;
}

const FamilyScoreCard: React.FC<IFamilyScoreCardProps> = ({
  selectedRecipient, caregiverId
}) => {
  const [moduleOverviewVisible, setModuleOverviewVisible] = useState(false);
  const [taskAssessmentVisible, setTaskAssessmentVisible] = useState(false);
  const [taskChecklistVisible, setTaskChecklistVisible] = useState(false);
  const [taskIndex, setTaskIndex] = useState(0);
  const [taskTitle, setTaskTitle] = useState(selectedRecipient.familyAssessment.questions[0].taskName || "");

  const setOverviewVisible = () => { setModuleOverviewVisible(true); };
  const setIndexOfTask = (idx: number) => { setTaskIndex(idx); };
  const setTitleOfTask = (title: string) => { setTaskTitle(title); }


  const questions = selectedRecipient.familyAssessment.questions;
  const renderModuleOverview = () => {
    return (
      <ModuleOverviewModal
        overviewBody={<FamilyModuleDescription />}
        hideOverview={() => setModuleOverviewVisible(false)}
        tasks={questions}
        assessment={selectedRecipient.familyAssessment}
        domain={moduleTitles.FAMILY}
        taskIndex={taskIndex}
        caregiverId={caregiverId}
        selectedRecipientId={selectedRecipient.id}
        selectedRecipientName={`${selectedRecipient.firstName} ${selectedRecipient.lastName}`}
        setTaskChecklistToVisible={() => setTaskChecklistVisible(true)}
        setAssessmentToVisible={() => setTaskAssessmentVisible(true)}
        setAssessmentHidden={() => setTaskAssessmentVisible(false)}
        setTaskIndex={setIndexOfTask}
        setTaskTitle={setTitleOfTask}
      />
    );
  };

  const renderTaskModal = () => {
    return (
      <TaskModal
        hideAssessment={() => setTaskAssessmentVisible(false)}
        taskIndex={taskIndex}
        taskTitle={taskTitle}
        recipient={selectedRecipient}
        assessment={selectedRecipient.familyAssessment}
        caregiverId={caregiverId}
        selectedRecipientId={selectedRecipient.id}
        selectedRecipientName={`${selectedRecipient.firstName} ${selectedRecipient.lastName}`}
        domain={moduleTitles.FAMILY}
        setTaskTitle={setTitleOfTask}
      />
    );
  };

  const renderTaskChecklistModal = () => {
    return (
      <TaskList
        assessment={selectedRecipient.familyAssessment}
        hideTaskList={() => setTaskChecklistVisible(false)}
      />
    );
  };

  return (
    <>
      {taskChecklistVisible && renderTaskChecklistModal()}
      {taskAssessmentVisible && renderTaskModal()}
      {moduleOverviewVisible && renderModuleOverview()}
      <ScoreMemberCard
        percentComplete={selectedRecipient.familyScoreComplete}
        selectedRecipient={selectedRecipient}
        icon={FamilyIcon}
        title={moduleTitles.FAMILY}
        overviewTitle="Family/Social Domain"
        videoLink={"undefined"}
        overviewBody={<FamilyModuleDescription />}
        assessment={selectedRecipient.familyAssessment}
        tasks={[]}
        setAssessmentVisible={setOverviewVisible}
        setModVisible={setOverviewVisible}
      />
    </>
  );
};

export default observer(FamilyScoreCard);
